import { GetProcessContentType } from "../../../Types/ticketProcessingTypes";

export const getBatchFailure = (startDate, endDate) =>
  `Invoices not generated due`;

export const getInvoiceDetailsModalContent = ({
  fromDate,
  toDate,
  isRange,
}) => {
  return {
    title: "Invoice Details",
    okButtonLabel: "Confirm",
    cancelButtonLabel: "Cancel",
    width: "46.625rem",
    question: !isRange
      ? `Are you sure you would like to process the invoice for the week of`
      : `Are you sure you would like to process the (selected) invoices?`,
    date: `${fromDate} - ${toDate} ?`,
    toBeProcessedHeader: "To be processed:",
    noteHeader: "Note:",
    noteContents:
      "Only tickets that have been completely verified are invoiced.",
  };
};

export const getProcessContents = (params?: GetProcessContentType) => {
  const {
    customers,
    jobs,
    dataInputCount,
    managerReviewCount,
    invoicedCount,
    approvedCount,
    totalCount,
  } = params ?? {
    customers: 0,
    jobs: 0,
    dataInputCount: 0,
    managerReviewCount: 0,
    invoicedCount: 0,
    approvedCount: 0,
    totalCount: 0,
  };
  return [
    {
      label: "Customers",
      value: customers,
    },
    {
      label: "Unique Jobs",
      value: jobs,
    },
    {
      label: "Data Input",
      value: dataInputCount,
    },
    {
      label: "Pending Review",
      value: managerReviewCount,
    },
    {
      label: "Invoices",
      value: invoicedCount,
    },
    {
      label: "Approved",
      value: approvedCount,
    },
    {
      label: "Tickets",
      value: totalCount,
    },
  ];
};
